var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from "@chakra-ui/react";
import { getPageHref } from "@/components/Pagination";
export var PageNumberButtons = function (_a) {
    var pageCursors = _a.pageCursors, searchParams = _a.searchParams, pageClickHandler = _a.pageClickHandler, countryParam = _a.countryParam;
    var buttons = Array.from(pageCursors.entries())
        .sort(function (a, b) { return a[0] - b[0]; })
        .map(function (pageCursor) {
        var pageNumber = pageCursor[0], cursor = pageCursor[1];
        var isActive = cursor == "";
        var href = isActive
            ? undefined
            : getPageHref(searchParams, cursor, countryParam);
        return (_jsx(Button, __assign({ asChild: true, "aria-current": isActive, "aria-label": isActive ? "current page, page ".concat(pageNumber) : "page ".concat(pageNumber), onClick: function (event) {
                return isActive ? undefined : pageClickHandler(event, cursor);
            }, variant: "pagination", className: isActive ? "active" : "" }, { children: _jsx("a", __assign({ href: href }, { children: pageNumber })) }), pageNumber));
    });
    return _jsx(_Fragment, { children: buttons });
};
